/**
 * Skicka med ett stort unitinfo objekt med parametrar från båda kalkylerna
 */

export enum CircularMotionScreenTypes {
  SJ = 'SJ',
  SA = 'SA',
}

export interface ScreeningMediaInterface {
  model?: string;
  description?: string;
  material?: string;
  type?: string;
  function?: string;
  separationSize?: SeparationSizeInterface;
  maxFeedSize?: MaxFeedSizeInterface;
}

export interface SeparationSizeInterface {
  metric: string;
  imperial: string;
}

export interface MaxFeedSizeInterface {
  metric: string;
  imperial: string;
}

/**
 * Efficiency måste vara ett objekt
 */
export interface DeckInterface {
  separationSize: number;
  screeningMedia?: ScreeningMediaInterface;
  screeningElement: { name: string; value: string };
  maxAmountOfOverUnderSize?: { name: string; value: string };
  openArea?: number;
  particleShape: { name: string; value: string };
  efficiency: { name: string; value: string };
  efficiencyNumber?: number;
  display: {
    separationSize: boolean;
    model: boolean;
    openArea: boolean;
    particleShape: boolean;
    efficiency: boolean;
    description: boolean;
    material: boolean;
    type: boolean;
    function: boolean;
  };
}

export interface CircularMotionScreenDeckMapInterface {
  0: DeckInterface;
  1: DeckInterface;
  2: DeckInterface;
  3: DeckInterface;
}
